import { P2GBox } from '@parcel2go/core-ui';

const QuoteResultPlaceholder = () => <P2GBox textAlign="center" p={3} />;

export default QuoteResultPlaceholder;
